<template>
	<div>
		<b-modal :ok-title="$t('misc.ok')" :cancel-title="$t('misc.cancel')" ref="saveWorkingModal" id="saveWorkingModal" :title="title" size="md" @ok="ok" @hidden="hidden" :ok-disabled="this.$store.state.ajax_in_progress">
			<div class="row">
				<div class="col-lg-12">
					<div class="row mb-3">
						<div class="col-lg-4">
							<label>{{ $t('table.working_group') }}</label>
						</div>
						<div class="col-lg-8">
							<multiselect v-model="model.team"
								:options="currentWorkingTeam"
								:multiple="false"
								:clear-on-select="true"
								:hide-selected="false"
								:loading="isWorkingTeamLoading"
								:preserve-search="true"
								placeholder=""
								label="name" track-by="id"
								:selectLabel="''"
								@search-change="onWorkingTeamSearch"
								@input="updateWorkingTeam"
							>
								<template slot="clear" slot-scope="props">
                                    <div 
                                        v-if="model.team != null" 
                                        class="multiselect__clear" 
                                        @mousedown.prevent.stop="clearSelectedWorkingTeam"
                                    >
                                    </div>
                                </template>
                                <span slot="noOptions">{{ $t('modal.general.list_is_empty') }}</span>
                                <span slot="noResult">{{ $t('modal.general.no_results') }}</span>
							</multiselect>
						</div>
					</div>

					<div class="row mb-3" v-if="model.team_id != null">
						<div class="col-lg-4">
							<label>{{ $t('table.team_member') }}</label>
						</div>
						<div class="col-lg-8">
							<multiselect v-model="model.user"
								:options="currentUser"
								:multiple="false"
								:clear-on-select="true"
								:hide-selected="false"
								:loading="isUserLoading"
								:preserve-search="true"
								placeholder=""
								label="fullname" track-by="id"
								:selectLabel="''"
								@search-change="onUserSearch"
								@input="updateUser"
							>
								<template slot="clear" slot-scope="props">
                                    <div 
                                        v-if="model.user != null" 
                                        class="multiselect__clear" 
                                        @mousedown.prevent.stop="clearSelectedUser"
                                    >
                                    </div>
                                </template>
                                <span slot="noOptions">{{ $t('modal.general.list_is_empty') }}</span>
                                <span slot="noResult">{{ $t('modal.general.no_results') }}</span>
							</multiselect>
						</div>
					</div>

					<div class="row mb-3">
						<div class="col-lg-4">
							<label>{{ $t('table.date') }}</label>
						</div>
						<div class="col-lg-8">
							<flat-pickr :config="{enableTime: false, inline: false}" class="form-control bg-white" v-model="model.date"/>
						</div>
					</div>

					<div class="row mb-3">
						<div class="col-lg-4">
							<label>{{ $t('table.progress_status') }}</label>
						</div>
						<div class="col-lg-8">
							<multiselect v-model="model.project_setting"
								:options="currentProgress"
								:multiple="false"
								:clear-on-select="true"
								:hide-selected="false"
								:loading="isProgressLoading"
								:preserve-search="true"
								placeholder=""
								label="info" track-by="id"
								:selectLabel="''"
								@search-change="onProgressSearch"
								@input="updateProgress"
							>
								<template slot="clear" slot-scope="props">
                                    <div 
                                        v-if="model.project_setting != null" 
                                        class="multiselect__clear" 
                                        @mousedown.prevent.stop="clearSelectedProgress"
                                    >
                                    </div>
                                </template>
                                <span slot="noOptions">{{ $t('modal.general.list_is_empty') }}</span>
                                <span slot="noResult">{{ $t('modal.general.no_results') }}</span>
							</multiselect>
						</div>
					</div>

					<div class="row mb-3">
						<div class="col-lg-4">
							<label>{{ $t('table.remark') }}</label>
						</div>
						<div class="col-lg-8">
							<textarea rows="6" maxlength="5000" class="form-control" v-model="model.remark"/>
						</div>
					</div>
				</div>
			</div>
		</b-modal>
	</div>
</template>

<script>
import Vue from 'vue';
import http from '@/libs/http';
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import * as notificationIcons from '@/components/global/miscellaneous/notificationIcons.js';
import miniToastr from 'mini-toastr';
import Multiselect from 'vue-multiselect';

export default {
	name: 'WorkingHistoryModal',
	components: {
		flatPickr,
		notificationIcons,
		Multiselect,
	},
	props: {
		item: {
			default: ''
		},
		title: {
			type: String,
			default: ''
		},
		table: {
			type: String,
			required: true
		},
		model: {
			type: Object,
			default: () => ({
				id: null,
				from_id: null,
				team_id: null,
				user_id: null,
				project_setting_id: null,
				date: null,
				remark: null,
				team: null,
				user: null,
				project_setting: null,
			})
		}
	},
	data() {
		return {
			isWorkingTeamLoading: false,
			currentWorkingTeam: [],

            currentUser: [],
            isUserLoading: false,

			isProgressLoading: false,
			currentProgress: [],

			workHistoryType: '',
		}
	},
	mounted() {
		this.workHistoryType = (this.table == 'pressure_test') ? 'progress_step_test_circuits' : 'piping_progress';
	},
	methods: {
		hidden(e) {
			this.$emit('hidden', e);
		},
		ok(e) {
			e.preventDefault();
			
			let mdl = {
				project_id: 		this.$route.params.id,        
				from_table:         this.table,
				from_id:            this.model.from_id,
				team_id:            this.model.team_id,
				user_id:            this.model.user_id,
				project_setting_id: (this.model.project_setting != null) ? this.model.project_setting.id : null,
				date:               this.model.date,
				remark:             this.model.remark
			}

			Object.keys(mdl).forEach(key => {
				if (mdl[key] === '') {
					mdl[key] = null;
				}
			});

			var vm = this;
			if (this.model.id != null) {
				http.route('history/'+this.model.id).patch(mdl, true).then(response => {
					if (!response.isError) {
						vm.$emit('onLoadTable', e);
						vm.$emit('onLoadTableMain', e);
						this.successMsg(Vue.i18n.translate('messages.working_history_updated'));
						this.hide();
					} else {
						Object.keys(response.errorMessage).forEach(key => {
							this.errorMsg(Vue.i18n.translate(response.errorMessage[key]));
						});
					}
				});
			} else {
				http.route('history').post(mdl, true).then(response => {
					if (!response.isError) {
						vm.$emit('onLoadTable', e);
						vm.$emit('onLoadTableMain', e);
						this.successMsg(Vue.i18n.translate('messages.working_history_created'));
						this.hide();
					} else {
						Object.keys(response.errorMessage).forEach(key => {
							this.errorMsg(Vue.i18n.translate(response.errorMessage[key]));
						});
					}
				});
			}
		},
		successMsg(msg) {
			miniToastr.success(msg, Vue.i18n.translate('messages.success'));
		},
		errorMsg(msg) {
			miniToastr.error(msg, Vue.i18n.translate('messages.error'));
		},
		cancel(e) {
			this.$emit('cancel', e);
		},
		shown(e) {
			this.errors.clear();
			this.$emit('shown', e);
		},
		show() {
			this.$refs.saveWorkingModal.show();
		},
		hide() {
			this.$refs.saveWorkingModal.hide();
		},
		clear() {
			this.currentTeam = [];
			this.currentUser = [];
			this.model.id = null;
			this.model.drawing_id = null;
			this.model.user_id = null;
			this.model.team_id = null;
			this.model.date = null;
			this.model.remark = null;
			this.model.team = null;
			this.model.user = null;
			this.model.project_setting = null;
			this.model.for_id = null;

			this.errors.clear();
		},
		onWorkingTeamSearch(search) {
			if (search == '') {
                this.currentWorkingTeam = [];
                
                return false;
            }
			
			this.isWorkingTeamLoading = true;
			this.searchWorkingTeam(search, this);
		},
		searchWorkingTeam: _.debounce((search, vm) => {
			http.route('team?project_id='+vm.$route.params.id+'&get_all=1&search_select=' + search).get().then(response => {
				if (response.data != false) {
					vm.currentWorkingTeam = response.data;
				}
				vm.isWorkingTeamLoading = false;
			});
		}, 500),
		updateWorkingTeam(team) {
			this.currentUser   = [];
			this.clearSelectedUser();

            if (team == null) {
                this.model.team_id = null;
            } else {
                this.model.team_id = team.id;
				let data = http.route('team/' + this.model.team_id +'/members?project_id='+this.$route.params.id).get();
				data.then(response => {
					this.currentUser = response.data;
					this.isUserLoading = false;
				});
            }
        },
		clearSelectedWorkingTeam () {
			this.model.team    = null;
			this.model.team_id = null;
			this.clearSelectedUser();
		},
		onUserSearch(search) {
			if (search == '') {
                this.currentUser = [];
                
                return false;
            }

			this.isUserLoading = true;
			this.searchUser(search, this);
        },
        searchUser: _.debounce((search, vm) => {
			let data = http.route('team/' + vm.model.team_id +'/members?project_id='+vm.$route.params.id+'&get_all=1&search_select=' + search).get();
			data.then(response => {
				if (response.data != false) {
					vm.currentUser = response.data;
				}
				vm.isUserLoading = false;
			});
        }, 500),
        updateUser(user) {
            this.model.user_id = (user != null) ? user.user_id : null;
        },
		clearSelectedUser () {
			this.model.user    = null;
			this.model.user_id = null;
		},
		onProgressSearch(search) {
			if (search == '') {
                this.currentProgress = [];
                
                return false;
            }

			this.isProgressLoading = true;
			this.searchProgressSearch(search, this);
		},
		searchProgressSearch: _.debounce((search, vm) => {
			let data = http.route("projectsetting?project_id="+ vm.$route.params.id + '&get_all=1&filters[type]='+vm.workHistoryType+'&search_select_key_and_value=' + search).get()
			data.then(response => {
				if (response.data != false) {
					vm.currentProgress = response.data;
				}
				vm.isProgressLoading = false;
			});
		}, 500),
		updateProgress(progress) {
			this.model.project_setting_id = (progress != null) ? progress.id : null;
		},
		clearSelectedProgress () {
			this.model.project_setting    = null;
			this.model.project_setting_id = null;
		},
	}
}
</script>


// WEBPACK FOOTER //
// src/components/global/modals/WorkingHistoryModal.vue